import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Header from "./Header";
import "./Accomodation.css";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { width } from "@mui/system";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const BookingSummary = () => {
  const navigate = useNavigate();
  const [aadhaar, setAadhaar] = useState("");
  let sumGrandTotalAmount = 0;
  localStorage.removeItem("bookingDetailsDataFinal");
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    localStorage.removeItem("bookingDetailsData");
  }
  if (localStorage.getItem("bookingDetailsData") == undefined) {
    navigate("/", "_self");
  }
  let billingRequest = JSON.parse(localStorage.getItem("billingRequest"));
  let bookingDetailsData = billingRequest.roomData;
  let bookingDetailsDataFinal = [];
  let seqNo = 1;
  console.log(billingRequest, "billingRequest");

  let srNo = 0;
  let grandTotal = 0;

  let captchSumValue = 0;

  const [logo1Loaded, setLogo1Loaded] = useState(false);
  // const [logo2Loaded, setLogo2Loaded] = useState(false);
  const [isPrintMode, setIsPrintMode] = useState(false);

  const handleLogo1Load = () => {
    setLogo1Loaded(true);
  };

  // const handleLogo2Load = () => {
  //   setLogo2Loaded(true);
  // };

  const printSummary = async () => {
    if (logo1Loaded) {
      return;
    }
    setIsPrintMode(true);

    const customerName = billingRequest.name.replace(/\s+/g, "");
    const currentDate = moment().format("DD-MMM-YYYY");
    const randomThreeDigitNumber = Math.floor(Math.random() * 900) + 100;
    const fileName = `${customerName}_${currentDate}_${randomThreeDigitNumber}.pdf`;

    const pdfOptions = {
      margin: 10,
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    const content = document.getElementById("print_content");

    var printContents = content.innerHTML;
    var cancellationPolicyContent =
      document.querySelector(".cancel-pol-note").innerHTML;
    printContents += `<div>${cancellationPolicyContent}</div>`;

    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;

    setTimeout(() => {
      window.print();
      document.body.innerHTML = originalContents;
      setIsPrintMode(false);
    }, 0);
  };

 
  

  return (
    <div>
      <Header />
      {/* <Navbar /> */}
      <div className="container" id="print_content">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="logos-container" style={{ textAlign: "center" }}>
              <img
                src="https://vmrdaprod-assests.s3.ap-south-1.amazonaws.com/VMRDA%20Logo%20%282%29.png"
                width="115px"
                height="100px"
                className="logo"
                alt="VMRDA Logo"
              />
            </div>
            <br />

            <h2 style={{ textAlign: "center" }}>Receipt</h2>
            <br />
           
            <div className="center_title">
              {billingRequest.razorpay_status === "captured" &&
                (billingRequest.purpose ===
                "Government Schools(school celebrations and cultural activities)" ? (
                  <span className="center_title_red">
                    Your payment is successfully completed. Please find the venue details below.
                  </span>
                ) : (
                  <span className="center_title_green">
                    Your payment has been successfully processed. Your booking is now confirmed.
                  </span>
                ))}
            </div>

            <br />

            <div className="col-md-12 billing_details_for">
              <div className="row">
                <div className="col-md-6" style={{width:"50%"}}>
                  <div className="row">
                    <div className="col-md-5" style={{width:"35%"}}>
                      <label for="exampleInputEmail1">Name :</label>
                    </div>
                    <div className="col-md-7" style={{width:"65%"}}>{billingRequest.name}</div>
                  </div>

                  <div className="row">
                    <div className="col-md-5" style={{width:"35%"}}>
                      <label for="exampleInputEmail1">Address :</label>
                    </div>
                    <div className="col-md-7" style={{width:"65%"}}>{billingRequest.address}</div>
                  </div>

                  <div className="row">
                    <div className="col-md-5" style={{width:"35%"}}>
                      <label for="exampleInputEmail1">Contact No :</label>
                    </div>
                    <div className="col-md-7" style={{width:"65%"}}>{billingRequest.contactno}</div>
                  </div>
                </div>

                {/* Second column */}
                <div className="col-md-6" style={{width:"50%"}}>
                  <div className="row">
                    <div className="col-md-5" style={{width:"35%"}}>
                      <label for="exampleInputEmail1">E-mail :</label>
                    </div>
                    <div className="col-md-7" style={{width:"65%"}}>{billingRequest.email}</div>
                  </div>

                  <div className="row">
                    <div className="col-md-5" style={{width:"35%"}}>
                      <label for="exampleInputEmail1">Proof :</label>
                    </div>
                    <div className="col-md-7" style={{width:"65%"}}>
                      {billingRequest.pan
                        ? "PAN submitted"
                        : billingRequest.aadhaar
                          ? "Aadhaar submitted"
                          : "No Proof available"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 center"></div>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Venue Name</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {bookingDetailsData.map((e, i) => {
                  grandTotal += e.finalGrandTotalVal
                    ? e.finalGrandTotalVal
                    : e.amount;
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{e.room_name}</td>
                      <td>{moment(e.bookingDate).format("DD-MMM-YYYY")}</td>
                      <td>{e.amount}</td>
                      <td>
                        {e.finalGrandTotalVal ? e.finalGrandTotalVal : e.amount}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan="3"></td>
                  <td>Grand Total</td>
                  <td>{grandTotal} /-</td>
                </tr>
              </tbody>
            </table>
           
            <button
              className="back_button float_left"
              onClick={() => navigate("/", "_self")}
            >
              Back
            </button>
            <button
              className="booking_button float_right"
              onClick={() => printSummary()}
            >
              Print
            </button>
            {/* <button className="booking_button float_right" onClick={() => generatePDF(billingRequest)}>Download PDF</button> */}

          </div>
        </div>

        <div
          className="cancel-pol-note"
          style={{
            display: isPrintMode ? "block" : "none",
            marginLeft: "50px",
          }}
        >
          <h1 className="cancel-pol-note-h1">Cancellation Terms & Conditions </h1>
          <br />
          <strong className="cancel-pol-notes" >In the event of cancellation of allotments made the following refund policy shall apply:</strong>
          <br/>
          {/* <ul className="cancel-pol-notes">

            <li>
            If the cancellation is made more than 30 days prior to the event date, VMRDA will retain 20% of the total amount and 80% of the amount will be refunded.
            </li>
            <li>
            If the cancellation is made more than 15 days but less than or equal to 30 days prior to the event, VMRDA will retain 30% of the total amount and 70% of the amount will be refunded.
            </li>
            <li>
            If the cancellation is made more than 5 days but less than or equal to 15 days prior to the event, VMRDA will retain 50% of the total amount and 50% of the amount will be refunded.
            </li>
            <li>
            If the cancellation is made more than 3 days but less than or equal to 5 days prior to the event, VMRDA will retain 70% of the total amount and 30% of the amount will be refunded.
            </li>
            <li>
            If the cancellation is made less than or equal to 3 days before the event, VMRDA will retain 100% of the amount and No refund will be provided.
            </li>
          </ul> */}
            <table
            border="1"
            cellPadding={8}
            cellSpacing={0}
            style={{ borderCollapse: "collapse", textAlign: "center" }}
          >
            <thead style={{ backgroundColor: "#f2f2f2" , fontWeight:"bold"}}>
              <tr style={{fontWeight:"bold"}}>
                <th>Cancellation of the Event</th>
                <th>Hold Amount by VMRDA</th>
                <th>Refund Amount to Customer</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Above 60 Days</td>
                <td>0%</td>
                <td>100%</td>
              </tr>

              <tr>
                <td>45 – 60 Days</td>
                <td>25%</td>
                <td>75%</td>
              </tr>
              <tr>
                <td>30 – 45 Days</td>
                <td>50%</td>
                <td>50%</td>
              </tr>
              <tr>
                <td>15 – 30 Days</td>
                <td>75%</td>
                <td>25%</td>
              </tr>
              <tr>
                <td>0 – 15 Days</td>
                <td>100%</td>
                <td>0%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default BookingSummary;
